
export const TOKEN_KEY = "sh-token"
export const TOKEN_EXPIRES_KEY = "sh-token-expires"
